<div class="header">
  <a class="header__title" appGoBack>
    <span class="material-symbols-outlined"> arrow_back </span>
    {{ title }}
  </a>
</div>
